import { Component, EventEmitter, Output } from '@angular/core';
import { PrettyConsole } from '@app/shared/utils';
import { TechFileUploaderModule } from '@tech/components/tech-file-uploader';

@Component({
  selector: 'input-file',
  standalone: true,
  imports: [TechFileUploaderModule],
  templateUrl: './input-file.component.html',
  styleUrl: './input-file.component.scss',
})
export class InputFileComponent {
  @Output() filesLoaded = new EventEmitter<File[]>();
  isDragOver = false;
  constructor() {}

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
    if (event.dataTransfer?.files.length) {
      this.handleFiles(event.dataTransfer.files);
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.handleFiles(input.files);
    }
  }

  private async handleFiles(files: FileList) {
    let emmited: File[] = [];
    for (let i = 0; i < files.length; ++i) {
      let file = files.item(i);
      if (file !== null) emmited.push(file);
    }

    this.filesLoaded.emit(emmited);
  }
}
